import React from 'react'
import Typography from '../../Typography'
import { useSelector } from 'react-redux';
import { StoreState } from '../../../../../store/reducer-main';
import ModeIcon from '@mui/icons-material/Mode';
import theme from '../../../../theme';
import ModifyBlock from './../ModifyBlock';
import InfoBox from '../InfoBox';
import CustomModal from '../../CustomModal';
import Button from '../../Button';
import { toast } from 'react-toastify';
import { authUpdatePassword, getCurrentUser, reauthUser } from '../../../../../service/common/firebase';
import { Input } from '@nextui-org/react';

export default function AuthSection() {

  const { userProfile } = useSelector((state: StoreState) => state.profile);

  const [modalOpen, setModalOpen] = React.useState<boolean>(false);
  const [password, setPassword] = React.useState<string>('');
  const [oldPassword, setOldPassword] = React.useState<string>('');
  const [loading, setLoading] = React.useState<boolean>(false);

  const submitDisbled = React.useMemo(() => {
    return oldPassword.length === 0 || oldPassword.length === 0;
  }, [password, oldPassword]);

  const submit = async () => {
    try {
      if (!userProfile?.email) return;
      const currentUser = getCurrentUser();
      if (!currentUser) return;
      setLoading(true);
      await reauthUser(currentUser, userProfile.email, oldPassword);
      await authUpdatePassword(currentUser, password);
      toast.success('Password aggiornata con successo');
      setModalOpen(false);
      setLoading(false);
    } catch (error) {
      console.log('err', error);
      toast.error('Si è virificato un errore durante la modifica della password, controlla le credenziali e riprova');
      setLoading(false);
    }
  }

  return (
    <div className='flex justify-between items-center my-5'>
      <div>
        <Typography variant='display'>
        AUTENTICAZIONE
        </Typography>
        <div className='flex gap-14 items-end mt-2'>
          <InfoBox title='Email' content={userProfile?.email??""}/>
          <InfoBox title='Password' content="********************"/>
          <ModifyBlock onClick={()=>setModalOpen(true)} modifyItem='Password'/>
        </div>
      </div>
      <CustomModal 
        isOpen={modalOpen}
        onOpenChange={setModalOpen}
        content={
          <div className='my-4'>
          <Typography style={{textAlign:"center"}} variant="display">Modifica password</Typography>
          <div className='flex flex-col justify-center my-4 gap-4'>
            <Input
              value={oldPassword} 
              onValueChange={setOldPassword} 
              type="password" 
              label="Password attuale" />
            <Input 
              value={password} 
              onValueChange={setPassword} 
              type="password" 
              label="Nuova password" />
            <Button 
              disabled={submitDisbled}
              loading={loading}
              onClick={submit}
              title='Aggiorna password' />
          </div>
        </div>
        } />
    </div>
  )
}
